import { render, staticRenderFns } from "./CampaignSetupPixelsCode.vue?vue&type=template&id=57ec7c52&"
import script from "./CampaignSetupPixelsCode.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupPixelsCode.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupPixelsCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports